/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

const pricingDetails = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  try {
    const res = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.pricingDetails}`,
      data: {},
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return res.data;
  } catch (err) {
    return await Promise.reject(new Error('Something wrong'));
  }
};

export default pricingDetails;
